import { FilterProvider } from "../../../contexts/Filters/FiltersContext";
import FilterMain from "./Main";
import "./styles.css";

const Filter = () => {
  return (
    <FilterProvider>
      <FilterMain />
    </FilterProvider>
  );
};
export default Filter;
